import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  paginationUl: {
    justifyContent: 'center',
  }
}));
